var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocRequestIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_1067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53805 19.2188H2.34375C1.48082 19.2188 0.78125 18.5192 0.78125 17.6562V2.34375C0.78125 1.48082 1.48082 0.78125 2.34375 0.78125H9.84375C10.2752 0.78125 10.6658 0.956133 10.9486 1.23891L12.5111 2.80141C12.7938 3.08414 12.9688 3.47477 12.9688 3.90625V8.21012",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5514 9.04621C17.1616 8.43601 18.1509 8.43601 18.7611 9.04621C19.3713 9.6564 19.3713 10.6457 18.7611 11.2559L12.3029 17.7142C12.1896 17.8274 12.0597 17.9226 11.9175 17.9963L9.7295 19.1313C9.43528 19.2839 9.06431 19.2368 8.81739 18.9899C8.57052 18.743 8.52341 18.3721 8.67602 18.0778L9.81099 15.8898C9.88474 15.7477 9.97989 15.6177 10.0931 15.5045L16.5514 9.04621Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 6.71875H9.84375",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 9.84375H9.84375",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 12.9688H6.71875",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_1067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocRequestIc);
export default __webpack_public_path__ + "static/media/doc-request-ic.7ae751d06bea1d8fb1fbcd143b47395d.svg";
export { ForwardRef as ReactComponent };